<template>
	<div class="card text-info overflow-auto" style="background-color: #263238">
		<div class="card-body" style="background-color: #263238">
			<h3 class="card-title mb-5">Team Stats</h3>
			<h5 v-show="userStats.length < 1" class="mt-5">No Stats to display</h5>
			<table
				v-show="userStats.length >= 1"
				class="table table-responsive table-hover table-dark text-info text-start"
				id="sortTable"
			>
				<thead>
					<tr>
						<th>Player</th>
						<th>AB</th>
						<th>H</th>
						<th>2B</th>
						<th>3B</th>
						<th>HR</th>
						<th>BB</th>
						<th>SO</th>
						<th>AVG</th>
						<th>OBP</th>
						<th>SLG</th>
					</tr>
				</thead>

				<tbody>
					<tr v-for="s in userStats" :key="s.stats">
						<th scope="row"><span v-if="s.number">#</span>{{ s.number }} {{ s.firstName }} {{ s.lastName }}</th>
						<td>{{ s.stats.atBats }}</td>
						<td>{{ s.stats.singles }}</td>
						<td>{{ s.stats.doubles }}</td>
						<td>{{ s.stats.triples }}</td>
						<td>{{ s.stats.homeruns }}</td>
						<td>{{ s.stats.walks }}</td>
						<td>{{ s.stats.so }}</td>
						<td>{{ s.BA.substring(1) }}</td>
						<td>{{ s.OBP.substring(1) }}</td>
						<td>{{ s.SLG.substring(1) }}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<th>Totals</th>
						<td>{{ teamTotals.atBats }}</td>
						<td>{{ teamTotals.hits }}</td>
						<td>{{ teamTotals.doubles }}</td>
						<td>{{ teamTotals.triples }}</td>
						<td>{{ teamTotals.homeruns }}</td>
						<td>{{ teamTotals.walks }}</td>
						<td>{{ teamTotals.so }}</td>
						<td>{{ teamTotals.avg.toFixed(3).substring(1) }}</td>
						<td>{{ teamTotals.obp.toFixed(3).substring(1) }}</td>
						<td>{{ teamTotals.slg.toFixed(3).substring(1) }}</td>
					</tr>
				</tfoot>
			</table>
		</div>
		<!-- <div class="card-footer" style="background-color: #263238"></div> -->
	</div>
</template>

<script>
export default {
	components: {},
	props: ['getUsers', 'compKey'],
	data() {
		return {
			teamTotals: {
				atBats: 0,
				hits: 0,
				doubles: 0,
				triples: 0,
				homeruns: 0,
				walks: 0,
				so: 0,
				avg: 0,
				obp: 0,
				slg: 0,
			},
			showTable: false,
			keyy: this.compKey
		};
	},
	created() {
		this.loadUsers()
	},
	watch: {
		keyy() {
			this.loadDataTables()
			console.log('run')
		}
	},
	computed: {
		userStats() {
			const statsArr = [];
			for (let i = 0; i < this.getUsers.length; i++) {
				if (this.getUsers[i].stats !== undefined) {
					statsArr.push(this.getUsers[i]);
				}
			}
			if (statsArr.length > 1) this.showTable = true;
			const userStatsArr = statsArr.map((i) => {
				return {
					...i,
					BA: (
						(i.stats.singles + i.stats.doubles + i.stats.triples + i.stats.homeruns) /
						i.stats.atBats
					).toFixed(3),
					OBP: (
						(i.stats.singles +
							i.stats.doubles +
							i.stats.triples +
							i.stats.homeruns +
							i.stats.walks +
							i.stats.hbp) /
						(i.stats.atBats + i.stats.walks + i.stats.hbp + i.stats.sf)
					).toFixed(3),
					SLG: (
						(i.stats.singles + 2 * i.stats.doubles + 3 * i.stats.triples + 4 * i.stats.homeruns) /
						i.stats.atBats
					).toFixed(3),
				};
			});
			if (userStatsArr.length > 1) {
				this.teamTotals.atBats = userStatsArr.map((i) => i.stats.atBats).reduce((a, b) => a + b);
				this.teamTotals.hits = userStatsArr.map((i) => i.stats.singles).reduce((a, b) => a + b);
				this.teamTotals.doubles = userStatsArr.map((i) => i.stats.doubles).reduce((a, b) => a + b);
				this.teamTotals.triples = userStatsArr.map((i) => i.stats.triples).reduce((a, b) => a + b);
				this.teamTotals.homeruns = userStatsArr.map((i) => i.stats.homeruns).reduce((a, b) => a + b);
				this.teamTotals.walks = userStatsArr.map((i) => i.stats.walks).reduce((a, b) => a + b);
				this.teamTotals.so = userStatsArr.map((i) => i.stats.so).reduce((a, b) => a + b);
				this.teamTotals.avg =
					userStatsArr.map((i) => Number(i.BA)).reduce((a, b) => a + b) / userStatsArr.length;
				this.teamTotals.obp =
					userStatsArr.map((i) => Number(i.OBP)).reduce((a, b) => a + b) / userStatsArr.length;
				this.teamTotals.slg =
					userStatsArr.map((i) => Number(i.SLG)).reduce((a, b) => a + b) / userStatsArr.length;
			}
			return userStatsArr;
		},
	},
	methods: {
		async loadUsers() {
			try {
				await this.$store.dispatch('fetchUsers');
				this.loadDataTables()
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
		},
		loadDataTables() {
			$(document).ready(function () {
				$('#sortTable').DataTable({
					aaSorting: [],
					autoWidth: true,
					order: [[0, 'desc']],
				});
				$('.dataTables_length').addClass('bs-select');
				$('.dataTables_length select').css('background-color', '#263238');
				$('.dataTables_length select').css('color', '#fff');
				$('.dataTables_filter input').css('background-color', '#263238');
				$('.dataTables_filter input').css('color', '#fff');
			});
		},
	},
};
</script>

<style scoped>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before {
	bottom: 1rem;
}
table.dataTable input {
	background-color: aqua;
}
</style>
